




































































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";

import LinearLoader from "@/components/LinearLoader/LinearLoader.vue";
import { clone } from "ramda";

type Column = {
  value: string;
  label: string;
  custom?: boolean;
  name?: string;
};

type Direction = "up" | "down";

@Component({
  components: {
    LinearLoader
  }
})
export default class DataTable extends Vue {
  /**
   * A loading state
   * @values true, false
   */
  @Prop({ default: false, type: Boolean })
  private loading!: boolean;

  /**
   * A table data
   * @values any array
   */
  @Prop({ default: () => [], type: Array })
  private data!: any[];

  /**
   * Row unique key. The item id property may be used here
   */
  @Prop({ required: true, type: String })
  private rowKey!: string;

  @Prop({ required: true, type: Array })
  private columns!: Column[];

  @Prop({ default: true, type: Boolean })
  private sortable!: boolean;

  /**
   * An array of column names that should be sorted, or a string 'all'
   */
  @Prop({ type: [Array, String], default: "all" })
  private sortableColumns!: "all" | string[];

  /**
   * An array of column names that should not be sorted
   */
  @Prop({ default: () => [], type: Array })
  private dontSort!: string[];

  private selectedArrow = "";

  private sortedData = this.data;

  private get tableColumns() {
    const custom: Column[] = [];
    const defaultColumns: Column[] = [];

    this.columns.forEach(item => {
      item.custom ? custom.push(item) : defaultColumns.push(item);
    });

    return {
      custom,
      default: defaultColumns
    };
  }

  private get isEmpty() {
    return !this.data || !this.data.length;
  }

  private isSortable(columnName: string) {
    if (this.dontSort.includes(columnName)) {
      return false;
    }

    return (
      this.sortableColumns === "all" ||
      this.sortableColumns.includes(columnName)
    );
  }

  private isSortArrowSelected(columnName: string, direction: Direction) {
    return this.selectedArrow === `${columnName}-${direction}`;
  }

  private sort(columnName: string, direction: Direction) {
    this.selectedArrow = `${columnName}-${direction}`;

    const isNumeric = this.data
      .map(row => row[columnName])
      .every(value => /^\d+$/.test(value));

    this.sortedData = clone(this.data).sort((a, b) => {
      if (isNumeric) {
        return direction === "up"
          ? a[columnName] - b[columnName]
          : b[columnName] - a[columnName];
      } else {
        return direction === "up"
          ? a[columnName].localeCompare(b[columnName])
          : b[columnName].localeCompare(a[columnName]);
      }
    });
  }

  @Watch("data")
  private onDataChanged() {
    this.sortedData = this.data;

    if (this.selectedArrow) {
      const sortData = this.selectedArrow.split("-");

      this.sort(sortData[0], sortData[1] as Direction);
    }
  }
}
